import { Button, Divider, Flex, LoadingOverlay, Paper, Text } from "@mantine/core";
import RolesTabs from "./components/roleTabs/RolesTabs";
import { useTranslation } from "react-i18next";
import { useRefetchServerActions } from "../../../redux/features/permissions/permissionsSlice";
import IconDeviceFloppy from "@tabler/icons-react/dist/esm/icons/IconDeviceFloppy.mjs";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { clearActionsChanges, useSelectActionsChanges } from "../../../redux/features/settings/settingsSlice";
import { changeAction } from "../../../services/actions";
import { getAxiosResponseError } from "../../../utils/functions";
import { useState } from "react";

const ActionsPanel = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const changedActionsChanges = useSelectActionsChanges();
  const refetchActionsData = useRefetchServerActions();
  const [loading, setLoading] = useState(false); //TODO replace with react query

  return (
    <Paper pos="relative" withBorder radius="md" style={{ overflow: "hidden" }}>
      <LoadingOverlay visible={loading} overlayBlur={2} />
      <Flex justify="space-between" align="center" p="sm">
        <Text size="md">
          {t("settings.actions")}
        </Text>
        <Button
          loading={false}
          leftSection={<IconDeviceFloppy />}
          onClick={saveBtnHandler}
          size="sm"
          disabled={!changedActionsChanges?.length}
        >
          SAVE
        </Button>
      </Flex>
      <Divider color="secondary.1" />
      <RolesTabs />
    </Paper>
  );

  async function saveBtnHandler() { // TODO replace with react query
    try {
      setLoading(true);
      await Promise.all(changedActionsChanges.map(changeAction));
      await refetchActionsData(); // refetchActionsData ()causes unwanted re-render of the whole component, needs to be optimized
      dispatch(clearActionsChanges())
      toast.success("Changes saved.");
    } catch (err) {
      console.error(err);
      toast.error(getAxiosResponseError(err));
    } finally {
      setLoading(false);
    }
  }
};

export default ActionsPanel;
